// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./FieldIcon.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, IconPrimitive } from "../_internal_primitives";
import * as icons from "../icons";

const styles = [
  {
    type: "default",
    layers: {
      GCCUsq6UFD: {
        none: {
          icon: icons.location,
          useMask: true,
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "small",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "small",
        layers: {},
      },
      {
        propValue: "large",
        layers: {},
      },
    ],
  },
  {
    type: "enum",
    propName: "color",
    values: [
      {
        propValue: "green",
        layers: {
          GCCUsq6UFD: {
            none: {
              useMask: true,
            },
          },
        },
      },
      {
        propValue: "purple",
        layers: {
          GCCUsq6UFD: {
            none: {
              useMask: true,
            },
          },
        },
      },
      {
        propValue: "blue",
        layers: {
          GCCUsq6UFD: {
            none: {
              useMask: true,
            },
          },
        },
      },
      {
        propValue: "orange",
        layers: {
          GCCUsq6UFD: {
            none: {
              useMask: true,
            },
          },
        },
      },
      {
        propValue: "red",
        layers: {
          GCCUsq6UFD: {
            none: {
              useMask: true,
            },
          },
        },
      },
    ],
  },
  {
    type: "boolean",
    propName: "clear",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "small",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "small",
        layers: {},
      },
      {
        propValue: "large",
        layers: {},
      },
    ],
  },
  {
    type: "enum",
    propName: "color",
    values: [
      {
        propValue: "green",
        layers: {},
      },
      {
        propValue: "purple",
        layers: {},
      },
      {
        propValue: "blue",
        layers: {},
      },
      {
        propValue: "orange",
        layers: {},
      },
      {
        propValue: "red",
        layers: {},
      },
    ],
  },
  {
    type: "boolean",
    propName: "clear",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "small",
  },
  {
    type: "enum",
    propName: "size",
    propValues: ["small", "large"],
  },
  {
    type: "enum",
    propName: "color",
    propValues: ["green", "purple", "blue", "orange", "red"],
  },
  {
    type: "boolean",
    propName: "clear",
  },
];

export const FieldIconContext = createContext(null);

function FieldIcon(_props) {
  const defaults = useContext(FieldIconContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="3vE7B4yeMH"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "3vE7B4yeMH",
        scope: "M2wqfRey1T",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <IconPrimitive
          id={"fieldIcon_GCCUsq6UFD"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_M2wqfRey1T_GCCUsq6UFD"
          }
          key={"GCCUsq6UFD"}
          useMask={getStyle("GCCUsq6UFD", "useMask")}
          src={exists(props.icon) ? props.icon : getStyle("GCCUsq6UFD", "icon")}
        />
      )}
    </RootPrimitive>
  );
}

FieldIcon.__variants = [
  {
    name: "small",
    type: "variant",
  },
  {
    name: "size",
    type: "group",
    variants: ["small", "large"],
  },
  {
    name: "color",
    type: "group",
    variants: ["green", "purple", "blue", "orange", "red"],
  },
  {
    name: "clear",
    type: "variant",
  },
];

export default FieldIcon;
